import EntityTypeEnum from 'common/enums/entityTypeEnum'
import EntityInterface from 'common/types/entities/EntityInterface'
import { OldEntityInterface } from 'common/types/entities/OldEntityInterface'
import { VideoInterface } from 'common/types/entities/VideoInterface'
import React from 'react'
import WebinarCallToAction from 'src/editor/pages/webinar-session/entities/webinar-call-to-action'
import { WebinarCallToActionEntityInterface } from 'src/shared/entities/webinar-call-to-action/webinar-call-to-action-entity.schema'
import createCommonEntityElement, {
  AdditionalProps,
} from '../createCommonEntityElement'
import WebinarSessionVideo from './entities/WebinarSessionVideo'

function createEntityElementForWebinarSession(
  entity: EntityInterface | OldEntityInterface,
  additionalProps: AdditionalProps,
) {
  switch (entity.type) {
    case EntityTypeEnum.WebinarSessionVideo:
      return (
        <WebinarSessionVideo
          entity={entity as VideoInterface}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.WebinarCallToAction:
      return (
        <WebinarCallToAction
          entity={entity as WebinarCallToActionEntityInterface}
          {...additionalProps}
        />
      )
    default:
      return createCommonEntityElement(entity, additionalProps)
  }
}

export default createEntityElementForWebinarSession
